<!-- Header
  ============================ -->
<header id="header" class="sticky-top">
    <!-- Navbar -->
    <nav class="primary-menu navbar navbar-expand-lg navbar-dark bg-dark border-bottom-0">
        <div class="container-fluid position-relative h-100 flex-lg-column ps-3 px-lg-3 pt-lg-3 pb-lg-2">

            <!-- Logo -->
            <a href="index.html" class="mb-lg-auto mt-lg-4">
                <span class="bg-dark-2 rounded-pill p-2 mb-lg-1 d-none d-lg-inline-block">
                    <img class="img-fluid rounded-pill d-block" src="assets/images/icon.png" title="Abdul Rahman Haroon"
                        alt="Abdul Rahman Haroon">
                </span>
                <h1 class="text-5 text-white text-center mb-0 d-lg-block">Abdul Rahman Haroon</h1>
                <span class="hide-se">
                    <hr />
                    <h3 class="text-3 text-white text-center mb-0 d-lg-block">Software Engineer &amp; MSc Cyber
                        Security</h3>
                    <hr />
                </span>
            </a>
            <!-- Logo End -->

            <div id="header-nav" class="collapse navbar-collapse w-100 my-lg-auto">
                <ul class="navbar-nav text-lg-center my-lg-auto py-lg-3">
                    <li class="nav-item"><a class="nav-link smooth-scroll active" href="#home">Home</a></li>
                    <li class="nav-item"><a class="nav-link smooth-scroll" href="#about">About Me</a></li>
                    <li class="nav-item"><a class="nav-link smooth-scroll" href="#skills">Skills</a></li>
                    <li class="nav-item"><a class="nav-link smooth-scroll" href="#resume">Resume</a></li>
                    <li class="nav-item"><a class="nav-link smooth-scroll" href="#achievements">Achievements</a></li>
                    <li class="nav-item"><a class="nav-link smooth-scroll" href="#contact">Contact</a></li>
                </ul>
            </div>
            <p class="follow-me" style="color:#20c997">Follow Me</p>
            <ul class="social-icons social-icons-muted social-icons-sm mt-lg-auto ms-auto ms-lg-0 d-flex">
                <li class="social-icons-twitter"><a data-bs-toggle="tooltip"
                        href="mailto:abdulrahman.haroonr@gmail.com" target="_blank" aria-label="Email"><i
                            class="fa-solid fa-envelope"></i></a></li>
                <li class="social-icons-facebook"><a data-bs-toggle="tooltip"
                        href="https://www.linkedin.com/in/abdul-rahman-haroon/" target="_blank"
                        aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a></li>
                <li class="social-icons-github"><a data-bs-toggle="tooltip" data-bs-placement="top"
                        href="https://github.com/abdulrahman-haroon" target="_blank" aria-label="GitHub"><i
                            class="fab fa-github"></i></a></li>
            </ul>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#header-nav"><span></span><span></span><span></span></button>
        </div>
    </nav>
    <!-- Navbar End -->
</header>
<!-- Header End -->
